import store from '@state/store'

export default [
  {
    path: '/',
    name: 'login',
    component: () => import('@views/login.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'users' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/kraunasi',
    name: 'loading',
    component: () => import('@views/_loading.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/galimybes',
    name: 'availability',
    component: () => import('@views/availability.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas',
    name: 'kids',
    component: () => import('@views/kids.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/ligonines',
    name: 'kids-hospital',
    component: () => import('@views/kids.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/kc',
    name: 'kids-kc',
    component: () => import('@views/kids.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/budejimai-grupese',
    name: 'group-duties',
    component: () => import('@views/group_duties.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/sukurti',
    name: 'kid-create',
    component: () => import('@views/kid_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/sukurti-istaiga',
    name: 'institution-create',
    component: () => import('@views/kid_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/sukurti-grupe',
    name: 'group-create',
    component: () => import('@views/kid_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grafikas/:id',
    name: 'kid-edit',
    component: () => import('@views/kid_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dokumentai',
    name: 'documents',
    component: () => import('@views/documents.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dokumentai/sukurti',
    name: 'document-create',
    component: () => import('@views/document_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dokumentai/:id/redaguoti',
    name: 'document-edit',
    component: () => import('@views/document_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dokumentai/:id/perziureti',
    name: 'document-preview',
    component: () => import('@views/document_preview.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/kalendorius',
    name: 'calendar',
    component: () => import('@views/events.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/kalendorius/sukurti',
    name: 'event-create',
    component: () => import('@views/event_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/kalendorius/:id',
    name: 'event-edit',
    component: () => import('@views/event_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/statistika',
    name: 'statistic',
    component: () => import('@views/statistic.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/savanoriai',
    name: 'users',
    component: () => import('@views/users.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/savanoriai/sukurti',
    name: 'user-create',
    component: () => import('@views/user_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/savanoriai/:id',
    name: 'user-edit',
    component: () => import('@views/user_form.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/zurnalas/:id',
    name: 'logs',
    component: () => import('@views/logs.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/valandos/:id',
    name: 'hours',
    component: () => import('@views/hours.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/slaptazodzio-priminimas',
    name: 'password-remind',
    component: () => import('@views/password-remind.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/slaptazodzio-priminimas-issiustas',
    name: 'password-remind-sent',
    component: () => import('@views/password-remind-sent.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/pakvietimas/:token',
    name: 'invitation',
    component: () => import('@views/invitation.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'users' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/pakeisti-slaptazodi/:token',
    name: 'password-change',
    component: () => import('@views/password-change.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/profilis',
    name: 'profile',
    component: () => import('@views/profile.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/atsijungti',
    name: 'logout',
    component: () => import('@views/logout.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
